import axios from 'axios';

export default {
  /**
   * Get names of available permissions
   */
  getNames() {
    return axios.post('/api/permission.getNames', {}).then((res) => res.data);
  },
};
